import { FC } from 'react';
import { RichTextField } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import styles from './partnerListComponent.module.scss';

const components: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.text}>{children}</p>,
};

type Props = {
  list: RichTextField;
};

export const PartnerListComponent: FC<Props> = ({ list }) => {
  return (
    <div className={styles.list}>
      <PrismicRichText field={list} components={components} />
    </div>
  );
};
